import { Visibility, VisibilityOff } from "@mui/icons-material";
import AdjustIcon from "@mui/icons-material/Adjust";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, FormControl, IconButton, Input, Modal, Typography } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import loadergif from "assets/gif/payment_processing.gif";
import successGif from "assets/gif/payment_success.gif";
import { memo, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { UserContext } from "../../../../../../../../App";
import sodexo from "../../../../../../../../assets/images/sodexo.png";
import { useSnackbar } from "../../../../../hooks/SnackbarProvider";
import usePrint from "../../../../../hooks/usePrint";
import { addpin } from "../../../../redux/Actions/SessionActions";
import StyledButton from "../../../custom/StyledButton";
import KeypadNewCartpage from "../keypad/index.js";
import "./index.css";

const CreditOrdersPaymentModal = (props) => {
  const dispatch = useDispatch();
  const paymentMethodsString = localStorage.getItem("paymentMethods");
  const payment_modes = paymentMethodsString?.split(",");
  const splitRef = useRef(null);
  const cancelRef = useRef(null);
  const [isVisible, setVisible] = useState(false);
  const toggleVisibility = () => setVisible((visible) => !visible);
  const { startPrint, isPrinting, connectPrinter, isError } = usePrint();

  const paymentButtons = useMemo(() => {
    const buttons = [
      { method: "CASH", icon: props?.cashIcon, label: "Cash" },
      { method: "UPI", icon: props?.upiIcon, label: "UPI" },
      { method: "CARD", icon: props?.cardIcon, label: "CARD" },
    ];

    if (payment_modes?.includes("SODEXO")) {
      buttons.push({ method: "SODEXO", icon: sodexo, label: "SODEXO" });
    }

    return buttons;
  }, [payment_modes]);

  let roundOffValue = undefined;

  const appConfigRaw = localStorage.getItem("appConfig");
  if (appConfigRaw) {
    const appConfig = JSON.parse(appConfigRaw);
    const roundOff = appConfig?.enabledFeatures?.ROUND_OFF;

    if (roundOff != null) {
      roundOffValue = parseFloat(roundOff);
    }
  }

  //useContext
  const { color } = useContext(UserContext);

  const showSnackbar = useSnackbar();

  const styleOffers = {
    position: "absolute",
    top: "45%",
    left: "45%",
    transform: "translate(-40%, -45%)",
    width: "55%",
    minHeight: "500px",
    bgcolor: color === "dark" ? "var(--dark-blue)" : "background.paper",
    borderRadius: "10px",
    boxShadow: 24,
    p: 4,
    overflowY: "scroll",
    color: color === "dark" ? "white" : "black",
    display: "flex",
  };

  const style = {
    position: "absolute",
    top: "45%",
    left: "45%",
    transform: "translate(-40%, -45%)",
    minHeight: "500px",
    bgcolor: color === "dark" ? "var(--dark-blue)" : "background.paper",
    borderRadius: "10px",
    boxShadow: 24,
    p: 4,
    overflowY: "scroll",
    color: color === "dark" ? "white" : "black",
    display: "flex",
  };

  const renderTotalAmount = useMemo(() => {
    let roundAmount = Number(props?.enterAmount);
    return `PAY ₹${
      props?.paymentMethod === "CASH" || roundOffValue ? Math.round(roundAmount) : roundAmount
    }`;
  }, [
    props?.partialStatus,
    props?.amountPaid,
    props?.adjustCheck,
    props?.splitActive,
    props?.amtToBePaid,
    props?.paymentMethod,
    props?.enterAmount,
    props?.amtHeading,
  ]);

  useEffect(() => {
    if (props?.openPayModal) {
      const handleKeyPress = (event) => {
        if (event.keyCode === 113) {
          if (!props?.functionCalled && !props?.partialStatus) {
            event.preventDefault();
            props?.settlePaymentFun();
            props?.setFunctionCalled(true);
          }
        } else if (event.keyCode === 8) {
          props?.setEnterAmount("");
        } else {
          props?.setFunctionCalled(false);
          props?.setCardFunctionCalled(false);
          props?.setSplitFunctionCalled(false);
        }
      };
      window.addEventListener("keydown", handleKeyPress);
      return () => {
        window.removeEventListener("keydown", handleKeyPress);
      };
    }
  }, [
    props?.openPayModal,
    props?.functionCalled,
    props?.paymentMethod,
    props?.cardFunctionCalled,
    props?.partialStatus,
    props?.enterAmount,
    props?.singleOrderoffline,
    props?.splitActive,
    props?.adjustCheck,
    props?.paymentFailed,
    props?.paymentSuccess,
    props?.manual,
    props?.paymentCancel,
    props?.newTransId,
  ]);

  useEffect(() => {
    props?.setPaymentMethod("CASH");
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      const { paymentMethod, openPayModal } = props;

      if (!openPayModal) return;

      switch (event.key) {
        case "ArrowRight":
          switch (paymentMethod) {
            case "CASH":
              props?.setPaymentMethod("UPI");
              break;
            case "UPI":
              props?.setPaymentMethod("CARD");
              break;
            case "CARD":
              if (payment_modes?.includes("SODEXO")) {
                props?.setPaymentMethod("SODEXO");
              } else {
                focusSplitButton();
              }
              break;
            case "SODEXO":
              focusSplitButton();
              break;
            default:
              break;
          }
          break;
        case "ArrowLeft":
          switch (paymentMethod) {
            case "SODEXO":
              blurSplitButton("CARD");
              break;
            case "CARD":
              blurSplitButton("UPI");
              break;
            case "UPI":
              props?.setPaymentMethod("CASH");
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
    };

    const focusSplitButton = () => {
      if (splitRef.current && !props?.splitActive) {
        splitRef.current.focus();
      } else if (cancelRef.current && props?.splitActive) {
        cancelRef.current.focus();
      }
    };

    const blurSplitButton = (payment_mode) => {
      props?.setPaymentMethod(payment_mode);
      if (splitRef.current) splitRef.current.blur();
      if (cancelRef.current) cancelRef.current.blur();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [
    props?.paymentMethod,
    props?.openPayModal,
    props?.splitActive,
    cancelRef,
    splitRef,
    props?.paymentFailed,
    props?.paymentSuccess,
    props?.manual,
    props?.paymentCancel,
  ]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (document.activeElement && document.activeElement.type === "number") {
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
          e.preventDefault();
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleSplitCancel = () => {
    props?.setSplitActive(false);
    props?.setPaymentMethod("CASH");
  };

  const handleOrderComplete = () => {
    props?.setPaymentSuccess(false);
    props?.closePaymentModal();
    props?.setOpen(true);
    props?.setPaymentMethod("CASH");
    props?.setpaymentLoader(false);
  };

  return (
    <>
      <Modal
        open={props?.openPayModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        {...(props?.partialStatus || props?.splitActive
          ? {}
          : { onClose: props?.closePaymentModal })}
      >
        <Box sx={props?.paymentLoader ? style : styleOffers}>
          {props?.paymentLoader ? (
            <>
              {props?.manual ? (
                <Box sx={{ width: "100%" }}>
                  <div className="process-wrapper-box">
                    <h3 className="process-wrapper-txt">Process your order manually</h3>
                    <h4>Customer Transaction Id</h4>
                    <FormControl sx={{ width: "100%" }} variant="outlined">
                      <Input
                        // onChange={(e) => settransId(e.target.value)}
                        className="input-wrapper-manual"
                        type="number"
                        disableUnderline
                        value={props?.transCode}
                      />
                    </FormControl>
                    <h4>Cashier Pin</h4>
                    <FormControl sx={{ width: "100%" }} variant="outlined">
                      <Input
                        onChange={(e) => dispatch(addpin(e.target.value))}
                        className="input-wrapper-manual"
                        type={isVisible ? "number" : "password"}
                        disableUnderline
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={toggleVisibility}
                              edge="end"
                            >
                              {isVisible ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </div>
                  <div className="bottom-btn-wrapper">
                    {/* <StyledButton onClick={handleCancelManual}>Cancel</StyledButton> */}
                    <StyledButton
                      loading={props?.approveloader}
                      disabled={!props?.cashierPin}
                      onClick={props?.handleManualorders}
                    >
                      Approve
                    </StyledButton>
                  </div>
                </Box>
              ) : (
                <>
                  {props?.paymentFailed ? (
                    <Box>
                      <h2 className="payemnt-failed-txt">
                        payment not processed -- <b className="orderNumber">{props?.newId}</b>
                      </h2>
                      <div className="failed-img-gif-wrapper">
                        <img className="failed-img-gif" src={props?.failedImgWarning} alt="Err" />
                      </div>
                      <div className="styledButton-wrapper-box">
                        {props?.cancelTrans ? (
                          <StyledButton onClick={props?.handleTansactionCancel}>
                            Cancel
                          </StyledButton>
                        ) : (
                          <StyledButton
                            loading={props?.cancelLoader}
                            onClick={props?.handleTansactionCancel}
                          >
                            Cancel
                          </StyledButton>
                        )}
                      </div>
                    </Box>
                  ) : props?.paymentSuccess ? (
                    <Box className="payment-success-main-box">
                      <div className="failed-img-gif-wrapper">
                        <img className="loading-img-gif-success" src={successGif} />
                      </div>
                      <Box className="payment-success-btn-wrapper-box">
                        {props?.isError && (
                          <StyledButton
                            variant="secondary"
                            loading={props?.isPrinting}
                            onClick={() =>
                              startPrint({
                                forcePick: true,
                                orderId: props?.newId || props?.orderId,
                              })
                            }
                            className="reprint-btn-wrapper"
                          >
                            Reprint Receipt(F12)
                          </StyledButton>
                        )}
                        <StyledButton
                          autoFocus
                          onClick={handleOrderComplete}
                          className="continue-btn-wrapper"
                        >
                          Continue
                        </StyledButton>
                      </Box>
                    </Box>
                  ) : props?.paymentCancel ? (
                    <Box>
                      <div className="failed-img-gif-wrapper">
                        <img className="loading-img-gif-success" src={props?.cancelGif} />
                      </div>
                      <h3 className="payment-cancel">Payment cancel</h3>
                      <StyledButton
                        className="cancel-wrapper-btn"
                        loading={props?.cancelLoader}
                        onClick={handleTansactionCancel}
                      >
                        Cancel
                      </StyledButton>
                    </Box>
                  ) : (
                    <Box>
                      <div>
                        <h4 className="payment-progress-text">{props?.paymentMethod} Payment</h4>
                        <div className="failed-img-gif-wrapper">
                          <img className="loading-img-gif" src={loadergif} alt="err" />
                        </div>
                        <div className="styledButton-wrapper-box">
                          <StyledButton
                            loading={props?.cancelLoader}
                            onClick={props?.handleTansactionCancel}
                          >
                            Cancel
                          </StyledButton>
                          {/* <StyledButton onClick={handleRetry}>Retry</StyledButton> */}
                          <StyledButton onClick={props?.handleManual}>Manual</StyledButton>
                        </div>
                      </div>
                    </Box>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <Box sx={{ width: props?.paymentMethod === "CASH" ? "50%" : "100%", flex: 1.5 }}>
                <div className="payment-split-active-stat">
                  <Typography variant="h4" className="payment-method-select">
                    Select Payment Mode
                  </Typography>
                </div>

                <div className="paymnet-floating-wrapper-container">
                  <div className="paymentIconsContainer-modal-I-keyboard" id="myDivPayment">
                    {paymentButtons?.map((button, index) => (
                      <button
                        key={index}
                        onClick={() => props.setPaymentMethod(button.method)}
                        className={
                          props?.paymentMethod === button.method
                            ? "activePaymentIcon-I"
                            : "paymenticons-I"
                        }
                      >
                        <img className="cashIcon-img" src={button.icon} alt="err" />
                        <b className="text-active-icon">{button.label}</b>
                      </button>
                    ))}
                  </div>

                  {props?.paymentMethod === "CASH" ? (
                    <div className="amount-main-wrapper-box-keyboard">
                      <div>
                        <div id="handleDisable" className="capture-amount-wrapper-keyboard">
                          <span className="total-txt-wrapper-span-keyboard">Change</span>
                          <h4>
                            ₹{Number(props?.enterAmount) - Math.round(Number(props?.amtToBePaid))}
                          </h4>
                        </div>
                      </div>
                      <div
                        id="handleDisable"
                        className="capture-amount-wrapper-keyboard"
                        style={{
                          marginBottom:
                            props?.enterAmount !== "" && props?.enterAmount !== "0" ? "0" : "2rem",
                        }}
                        onClick={() => props?.enterAmountRef?.current.focus()}
                      >
                        <span className="total-txt-wrapper-span-keyboard">Enter amount</span>
                        <input
                          autoFocus
                          type="number"
                          value={props?.enterAmount}
                          onChange={(e) => props?.setEnterAmount(e.target.value)}
                          ref={props?.enterAmountRef}
                          inputProps={{ inputMode: "numeric" }}
                          className="enter-amount-input-tag-keyboard"
                        />
                      </div>

                      {props?.enterAmount !== "" &&
                      props?.enterAmount !== "0" &&
                      props?.amtHeading !== "Recievable Amount" ? (
                        <div className="clearing-message-payment">
                          <InfoOutlinedIcon className="clearing-icon-payment" />{" "}
                          <p>Press backspace to clear the amount entered</p>
                        </div>
                      ) : null}
                    </div>
                  ) : (
                    <div className="paymentCalContainer-split-keyboard">
                      <div className="split-method-wrapper-keyboard">
                        <span className="total-txt-wrapper-span-keyboard">Cart value</span>
                        <h4 className="split-text-bold">₹{props?.amtToBePaid}</h4>
                      </div>

                      <div
                        className="capture-amount-wrapper-keyboard"
                        onClick={() => props?.enterAmountRef?.current.focus()}
                      >
                        <span className="total-txt-wrapper-span-keyboard">Enter amount</span>
                        <input
                          autoFocus
                          className="enter-amount-input-tag-keyboard-split"
                          type="number"
                          ref={props?.enterAmountRef}
                          value={props?.enterAmount}
                          onChange={(e) => props?.setEnterAmount(e.target.value)}
                          inputProps={{ inputMode: "numeric" }}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="sub-total-main-wrapper-conatiner-key">
                  <StyledButton
                    disabled={props?.outStandingAmount == 0}
                    color="rgb(80, 200, 120)"
                    loading={props?.newLoader || props?.modalLoader || props?.payLoader}
                    id="confirm-wrapper-btn"
                    className="sub-total-wrapper-container-I-keyboard-payment-page"
                    onClick={props?.settlePaymentFun}
                  >
                    <b className="total-text-box">(F2)</b> {renderTotalAmount}
                  </StyledButton>
                </div>
                {/* <CompleteOrder/> */}
              </Box>
            </>
          )}

          {props?.paymentMethod === "CASH" && !props?.paymentLoader ? (
            <KeypadNewCartpage
              setEnterAmount={props.setEnterAmount}
              enterAmount={props.enterAmount}
            />
          ) : null}
        </Box>
      </Modal>
    </>
  );
};

export default memo(CreditOrdersPaymentModal);
